export default "__VITE_ASSET__DSbXMC0g__"